import prepareComponent from "@bluframe/grapple/prepareComponent"
import identity from "ramda/src/identity"

import Pagination from "./Pagination"

export interface Props {
  hasNextData?: boolean
  hasPrevData?: boolean
  link?: string
  next?: string | null
  prev?: string | null
  page?: number
  totalPages?: number
}

export interface ComponentProps extends Props {
  link: string
}

const hasPagination = ({ hasNextData, hasPrevData, link }: Props): boolean =>
  Boolean((hasNextData || hasPrevData) && link)

// @ts-expect-error -- prepareComponent typing
export default prepareComponent<Props, ComponentProps>(identity, {
  onlyRenderIf: hasPagination
})(Pagination)
